import bigcommerce from './bigcommerce';
import shopify from './shopify';
import templateConnection from './template-connection';
import templateConnectionStatistic from './template-connection-statistic';
import appConnection from './app-connection';
import checkout from './checkout';
import customerEmail from './customer-email';
import customerEmailEvent from './customer-email-event';
import emailTemplate from './email-template';
import setting from './setting';
import payment from './payment';
import product from './product';

export default {
	bigcommerce,
	shopify,
	templateConnection,
	templateConnectionStatistic,
	checkout,
	appConnection,
	customerEmail,
	customerEmailEvent,
	emailTemplate,
	setting,
	payment,
	product
};



// WEBPACK FOOTER //
// ./src/helpers/chated-client/index.js